const img = require('./porchSideC.svg'); export default img;